import {LoginLink, Search} from '../navigation'
import { mountOnId } from 'shared'

document.addEventListener("DOMContentLoaded", () => {
  mountOnId(LoginLink, 'header-login-mountpoint')
  mountOnId(Search, 'header-search-mountpoint')
})
